import type { ReactNode } from 'react';
import { AppLoadingScreen } from '../components/AppLoadingScreen';
import {
  BankWorkspaceBridge,
  BusinessOpportunitiesBridge,
  LegalEntitiesBridge,
  RealEstateWorkspaceBridge,
} from './AppDataContext';
import { useFirestoreWorkspaceState } from '../hooks/useFirestoreWorkspaceState';

type Props = {
  userId: string;
  children: ReactNode;
};

export function FirestoreAppDataProvider({ userId, children }: Props) {
  const workspace = useFirestoreWorkspaceState(userId);

  if (workspace.loading) {
    return <AppLoadingScreen variant="workspace" />;
  }

  if (workspace.error) {
    return (
      <div className="appFullBleedCenter appFullBleedCenterColumn">
        <p>Could not load workspace data.</p>
        <pre>{workspace.error}</pre>
      </div>
    );
  }

  const value = {
    financialItems: workspace.financialItems,
    setFinancialItems: workspace.setFinancialItems,
    companies: workspace.companies,
    setCompanies: workspace.setCompanies,
    investmentCases: workspace.investmentCases,
    setInvestmentCases: workspace.setInvestmentCases,
    updates: workspace.updates,
    setUpdates: workspace.setUpdates,
    monthlyUpdates: workspace.monthlyUpdates,
    setMonthlyUpdates: workspace.setMonthlyUpdates,
  };

  return (
    <BankWorkspaceBridge userId={userId} workspace={value}>
      <RealEstateWorkspaceBridge userId={userId}>
        <BusinessOpportunitiesBridge userId={userId}>
          <LegalEntitiesBridge userId={userId}>{children}</LegalEntitiesBridge>
        </BusinessOpportunitiesBridge>
      </RealEstateWorkspaceBridge>
    </BankWorkspaceBridge>
  );
}
